import React, { useState, useEffect, useRef } from "react";

import { FaCaretDown } from "react-icons/fa";
import { ReactComponent as CalenderIcon } from "../icons/custom-calender-icon.svg";

//import resize function
import { vw, vh } from "./resizeFunction";

const DropdownSelect = ({
  choices,
  defaultChoice,
  onSelect,
  backgroundColor,
  textColor,
  border,
  borderRadius,
  padding,
  showIcon,
  showScrollbar = true,
}) => {
  const [selectedChoice, setSelectedChoice] = useState(defaultChoice || "");
  const [isOpen, setIsOpen] = useState(false);

  // add refs to manage injected style and unique class name
  const scrollClassRef = useRef(
    `dropdown-scroll-${Math.random().toString(36).substr(2, 9)}`
  );
  const styleTagRef = useRef(null);

  useEffect(() => {
    // Update selectedChoice when defaultChoice changes, including from empty to valid value
    if (defaultChoice) {
      setSelectedChoice(defaultChoice);
    }
  }, [defaultChoice]);

  // inject/remove style to hide scrollbar when requested and dropdown is scrollable
  useEffect(() => {
    const className = scrollClassRef.current;

    // remove previous style tag if present
    if (styleTagRef.current) {
      styleTagRef.current.remove();
      styleTagRef.current = null;
    }

    if (!showScrollbar && choices && choices.length > 8) {
      const style = document.createElement("style");
      style.type = "text/css";
      style.innerHTML = `
        .${className} { scrollbar-width: none; -ms-overflow-style: none; }
        .${className}::-webkit-scrollbar { display: none; }
      `;
      document.head.appendChild(style);
      styleTagRef.current = style;
    }

    return () => {
      if (styleTagRef.current) {
        styleTagRef.current.remove();
        styleTagRef.current = null;
      }
    };
  }, [showScrollbar, choices]);

  const styles = {
    dropdown: {
      position: "relative",
      display: "inline-block",
      width: "100%",
      // zIndex: 1000,
    },
    dropbtn: {
      textAlign: "left",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      backgroundColor: backgroundColor ? backgroundColor : "transparent",
      cursor: "pointer",
      padding: padding ? padding : vh(10),
      marginBottom: vh(10),
      borderRadius: borderRadius ? borderRadius : vh(5),
      border: border ? border : "1px solid #ccc",
      fontSize: vh(16),
      color: textColor ? textColor : "#192A3A",
    },
    dropdownContent: {
      display: isOpen ? "block" : "none",
      position: "absolute",
      backgroundColor: "#f9f9f9",

      minWidth: vw(160),
      width: "100%",
      boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)",
      zIndex: 9999,
      borderRadius: borderRadius ? borderRadius : 0,
      // if more than 8 choices, make the dropdown scrollable
      ...(choices && choices.length > 8
        ? { maxHeight: vh(380), overflowY: "auto" }
        : {}),
    },
    dropdownItem: {
      color: "black",
      padding: `${vh(12)} ${vh(16)}`,
      textDecoration: "none",
      display: "block",
      cursor: "pointer",
    },
    arrow: {
      marginLeft: vw(10),
      transition: "transform 0.3s ease",
      transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
    },
  };

  return (
    <div style={styles.dropdown}>
      <button
        type="button"
        style={styles.dropbtn}
        onClick={() => setIsOpen(!isOpen)}
      >
        {showIcon && (
          <div
            style={{
              // backgroundColor: "#E2E8EE",
              backgroundColor: "#E2E8EE",
              marginRight: vw(7),
              marginTop: vh(1),
              padding: `${vh(5)} ${vh(7)}`,
              borderRadius: "50%",
            }}
          >
            <CalenderIcon
              style={{ height: "15px", width: "15px", marginTop: vh(1) }}
            />
          </div>
        )}
        {selectedChoice}
        <span style={styles.arrow}>
          <FaCaretDown />
        </span>
      </button>
      <div
        style={styles.dropdownContent}
        className={
          choices && choices.length > 8 && !showScrollbar
            ? scrollClassRef.current
            : ""
        }
      >
        {choices.map((choice, index) => (
          <div
            key={choice}
            style={{
              ...styles.dropdownItem,
              ...(index === 0 && {
                borderTopLeftRadius: borderRadius ? borderRadius : 0,
                borderTopRightRadius: borderRadius ? borderRadius : 0,
              }),
              ...(index === choices.length - 1 && {
                borderBottomLeftRadius: borderRadius ? borderRadius : 0,
                borderBottomRightRadius: borderRadius ? borderRadius : 0,
              }),
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#f1f1f1")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#f9f9f9")}
            onClick={() => {
              setSelectedChoice(choice);
              setIsOpen(false);
              onSelect(choice);
            }}
          >
            {choice}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DropdownSelect;
